import { z } from "zod";

export const testResultEntrySchema = z.object({});
export type TestResultEntryValues = z.infer<typeof testResultEntrySchema>;
